import styled from 'styled-components'

export const Page = styled.main`
    width: 100%;
    max-width: 1560px;
    margin: 0 auto;
    padding: 92px clamp(18px, 2.4vw, 36px) 56px;
    animation: competitiveIntelligenceReveal 0.42s ease both;

    @keyframes competitiveIntelligenceReveal {
        from { opacity: 0; transform: translateY(8px); }
        to { opacity: 1; transform: translateY(0); }
    }

    @media (prefers-reduced-motion: reduce) { animation: none; }
`;

export const Operations = styled.div`
    min-height: 40px;
    margin: 12px 0 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 12px;
    color: ${({ theme }) => theme.palette.colors.subdued};
`;

export const Freshness = styled.span`
    font-size: 13px;
    line-height: 1.4;
`;

export const SyncFeedback = styled.span`
    font-size: 13px;
    line-height: 1.4;
    color: ${({ theme, $error }) => ($error ? theme.palette.colors.red : theme.palette.colors.muted)};
`;

export const SyncButton = styled.button`
    min-height: 34px;
    padding: 7px 11px;
    border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    border-radius: 9px;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: ${({ theme }) => theme.palette.colors.buttonGhost};
    color: ${({ theme }) => theme.palette.colors.muted};
    font: inherit;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: border-color 0.18s ease, color 0.18s ease, background 0.18s ease;

    svg {
        width: 15px;
        height: 15px;
        animation: ${({ $syncing }) => ($syncing ? 'competitiveIntelligenceSpin 0.8s linear infinite' : 'none')};
    }

    &:hover:not(:disabled), &:focus-visible {
        color: ${({ theme }) => theme.palette.blue.main};
        border-color: ${({ theme }) => theme.palette.blue.main};
    }

    &:focus-visible { outline: 2px solid ${({ theme }) => theme.palette.colors.shellGlow}; outline-offset: 2px; }
    &:disabled { cursor: default; opacity: 0.66; }

    @keyframes competitiveIntelligenceSpin { to { transform: rotate(360deg); } }
    @media (prefers-reduced-motion: reduce) { svg { animation: none; } }
`;
